<header class="header-area" id="header-sticky">
  <nav class="navbar navbar-expand-lg site-logo-bann p-0">
    <div class="container">
      <a class="navbar-brand" routerLink="home"> <img lazyLoad="assets/img/logo.png" /></a>
      <!-- <button *ngIf="isLoggedIn" class="navbar-toggler" type="button" data-bs-toggle="collapse" -->
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
        data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="menu_container">
        <div class="btn_container" (click)="showSidebar()">
          <label *ngIf="newNotification" class="notification-dot-header"></label>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="over_lay"></div>
        <app-sidebar></app-sidebar>
      </div>
      <div class="collapse navbar-collapse smart-main-menu" id="navbarNav">
        <ul id="menu" class="navbar-nav " style="margin-bottom: 0;align-items: center;">
          <li class="nav-item"><a class="nav-link active" aria-current="page" routerLink="home">Home</a></li>
          <li class="nav-item"><a class="nav-link" routerLink="directory">Directory</a></li>
          <li class="nav-item"><a class="nav-link" routerLink="post">Business Post</a></li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button"
              data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Tools
            </a>

            <ul class="nav-item dropdown head_menu_drop_li pl-0" aria-labelledby="navbarDropdownMenuLink">
              <li>
                <a class="dropdown-item" routerLink="page/specification">Specification</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="page/packing-details-domestic">Packing Details (Domestic)</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="page/packing-details-export">Packing Details (Export)</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="tool/tiles-calculator">Tiles Calculator</a>
              </li>
            </ul>
          </li>
          <li class="nav-item"><a class="nav-link" routerLink="exhibition">Exhibition</a></li>
          <!-- <li class="nav-item"></li> -->
          <li class="nav-item"><div id="google_translate_element"></div></li>
        </ul>
      </div>

      <div class="df-head-menu-banner" *ngIf="isBrowser">
        <!-- <div id="google_translate_element"></div> -->
        <div class="top-right" *ngIf="!user?.id">
          <a routerLink="login">SIGN IN</a>
          <a routerLink="register">REGISTER</a>
        </div>
        <div class="top-right-loggedin" *ngIf="user?.id">
          <img lazyLoad="{{ user?.profile }}" alt="user" class="user-image-header" />
          <a>{{ user?.name }}</a>
          <ul id="submenu" class="ps-0">
            <li><a routerLink="profile">My Profile</a></li>
            <li><a routerLink="inbox">Inquiry <span class="sidebar-count" *ngIf="inboxCount">{{inboxCount}}</span> </a>
            </li>
            <li><a routerLink="notifications">Notification <span class="sidebar-count"
                  *ngIf="notificationCount">{{notificationCount}}</span></a></li>
            <li><a routerLink="analytics">Analytics</a></li>
            <li><a routerLink="digital-card">Digital Visiting Card</a></li>
            <li><a routerLink="/help-support"> Help &amp; Support </a></li>
            <li (click)="logout()"><a> Logout </a></li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</header>